import {
  Component,
  EventEmitter,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'admin-app-tab-selection',
  templateUrl: './tab-selection.component.html',
  styleUrls: ['./tab-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, TranslatePipe]
})
export class TabSelectionComponent implements OnInit, OnChanges {
  readonly defaultSelection = input<string>(undefined);
  readonly tabNames = input<string[]>(undefined);
  readonly distributionTabSelection = input<boolean>(undefined);
  readonly allocationTabSelection = input<boolean>(undefined);
  readonly showBorder = input<boolean>(undefined);
  readonly disabled = input<boolean>(undefined);
  readonly displayFn = input<(text: string) => string>(undefined);
  readonly disableAutomaticSelection = input<boolean>(undefined);

  @Output() changeSelectionTab = new EventEmitter<string>();

  public selectedTab: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultSelection) {
      this.selectedTab = changes.defaultSelection?.currentValue || this.tabNames()[0];
    }
  }

  ngOnInit(): void {
    const defaultSelection = this.defaultSelection();
    this.selectedTab = defaultSelection ? defaultSelection : this.tabNames()?.[0];
  }

  public changeSelection(tab: string): void {
    if (this.selectedTab === tab) {
      return;
    }

    if (this.disableAutomaticSelection()) {
      this.changeSelectionTab.emit(tab);
    } else {
      this.selectedTab = tab;
      this.changeSelectionTab.emit(this.selectedTab);
    }
  }

  public displayText(text: string): string {
    const displayFn = this.displayFn();
    return displayFn ? displayFn(text) : text;
  }
}
